import React, { useMemo } from 'react';
import { useQuery } from 'react-query';
import { VendorEventMapCanvas, type VendorSearchItem } from '@goodfynd/maps';
import { Text } from '@goodfynd/ui';
import { Link } from '@goodfynd/ui';
import { useVendor } from 'context/VendorContext';
import { getDashboardRoutePath } from 'utils/routes-util';

import config from '../../../config';
import routes from '../../../config/routes';
import { useVendorApi } from '../../../hooks/api';
import useVendorMap from '../../../hooks/useVendorMap';
import type { SearchResults } from '../../../types/search-legacy';
import type { VendorScheduleRequest } from '../../../types/vendors';
import { OverviewCard } from '../overview-card';

import { PreOrderingPinHover } from './pre-ordering-pin-hover';

export default function VendorPreOrderingOverview() {
  const { vendor, vendorId } = useVendor();
  const { map } = useVendorMap({ vendorId });
  const api = useVendorApi();

  /* Fetch schedule events open for pre-ordering */
  const request = useMemo<VendorScheduleRequest>(
    () => ({
      page: 1,
      rows: 100,
      vendorIds: vendor?.id,
    }),
    [vendor?.id]
  );
  const { data, isError, isLoading } = useQuery<
    SearchResults<VendorSearchItem>,
    unknown
  >([config.queryKeys.openVendors, vendor.nameId], () =>
    api.getOpenVendors(request)
  );

  return (
    <OverviewCard
      headerCss={{ padding: '16px 16px 8px' }}
      id="overview-upcoming-schedule"
      showDateFilter={false}
      title="Upcoming Schedule"
      contentCss={{
        height: 'calc(100% - 44px)',
        marginTop: -24,
      }}
      css={{
        overflow: 'hidden',
        padding: 0,
      }}
      titleRight={
        <Link
          href={getDashboardRoutePath(
            routes.dashboard.schedule.map,
            vendor.nameId
          )}
        >
          <Text as="subhead3" inherit>
            Expand
          </Text>
        </Link>
      }
    >
      <VendorEventMapCanvas
        busy={isLoading && '...loading map...'}
        defaultCenter={map?.baseLocation}
        defaultZoom={9}
        error={isError && 'An unknown error has occurred'}
        renderMarkerHoverInfo={(info) => <PreOrderingPinHover item={info} />}
        results={data?.results}
      />
    </OverviewCard>
  );
}
